import { Injectable } from '@angular/core';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { CmsErrorPage } from '@error/util-models';
import { combineLatest, Observable } from 'rxjs';

export interface ViewModel {
  cmsData: CmsErrorPage;
}

@Injectable()
export class ErrorComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(private readonly cmsContainer: CmsContainer<CmsErrorPage>) {}
}
